import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <CartProvider>
      <WishlistProvider>
        <App />
        <ToastContainer position="top-center" autoClose={2000} />
      </WishlistProvider>
    </CartProvider>

);
